export default __webpack_public_path__ + "static/media/usage.83d13716.svg";